import React, { useState } from 'react'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import Requests from './Requests';
import EditRequest from './edit-request/EditRequest';
import Orders from './orders/Orders';
import Delivery from './delivery/Delivery';
import CreateDelivery from './details-request/CreateDelivery';
import Tabs from '../../../components/general/general-component/tabs/Tabs';
import { UsePermissions, hasPermissions } from '../../../components/general/general-component/abstruct-component/UsePermissions';
import CheckPermissions from '../../../components/general/general-component/check-permissions';
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader';

function Sequence() {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const materials_requests = hasPermissions([{ name: "materials-requests" }], permissionss);
    const materials_orders = hasPermissions([{ name: "materials-orders" }], permissionss);
    const materials_deliveries = hasPermissions([{ name: "materials-deliveries" }], permissionss);
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang();
    const [activeSection, setActiveSection] = useState('Requests');
    const [activeId, setActiveId] = useState(null);
    const [orderId, setOrderId] = useState(null);
    const handleSectionClick = (sectionId) => {
        /*if(sectionId === 'order' && activeId === null ){
            setActiveSection('requests');
        }else{setActiveSection(sectionId);}*/
        setActiveSection(sectionId);
    };
    const tabs = [
        {
            name: translate('requests'),
            type: 'Requests',
            icon: 'fa-solid fa-file-import'
        },
        {
            name: translate('orders'),
            type: 'Order',
            icon: 'fa-solid fa-arrow-turn-down'
        },
        {
            name: translate('delivery'),
            type: 'Delivery',
            icon: 'fa-solid fa-check'
        }
    ]
    return (
        <CheckLazyLoader>
            <main>
                <div className="div_table2 margin_main shadow_main" dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                    <Tabs langLocal={langLocal} tabs={tabs} activeSection={activeSection} handleSectionClick={handleSectionClick} setActiveId={setActiveId} setOrderId={setOrderId} />
                    {
                        activeSection === 'Requests' && (
                            <CheckPermissions array={materials_requests} loadingMainPermission={loadingMainPermission} >
                                <Requests setActiveSection={setActiveSection} setActiveId={setActiveId} />
                            </CheckPermissions>
                        )
                    }
                    {
                        activeSection === 'Order' && activeId === null && (
                            <CheckPermissions array={materials_orders} loadingMainPermission={loadingMainPermission} >
                                <Orders setActiveSection={setActiveSection} setOrderId={setOrderId} />
                            </CheckPermissions>
                        )
                    }
                    {
                        activeSection === 'Order' && activeId !== null && (
                            <CheckPermissions array={materials_orders} loadingMainPermission={loadingMainPermission} >
                                <EditRequest translate={translate} langLocal={langLocal} activeId={activeId} />
                            </CheckPermissions>
                        )
                    }
                    {
                        activeSection === 'Delivery' && orderId === null && (
                            <CheckPermissions array={materials_deliveries} loadingMainPermission={loadingMainPermission} >
                                <Delivery />
                            </CheckPermissions>
                        )
                    }
                    {
                        activeSection === 'Delivery' && orderId !== null && (
                            <CheckPermissions array={materials_deliveries} loadingMainPermission={loadingMainPermission} >
                                <CreateDelivery />
                            </CheckPermissions>
                        )
                    }
                </div>
            </main>
        </CheckLazyLoader>
    )
}

export default Sequence